import { dehydrate, DehydratedState, QueryClient } from "@tanstack/react-query";
import type { GetServerSideProps, NextPage } from "next";

import Seo from "@/components/common/Seo";
import { ESeoPage } from "@/utils/mockData/metaMocks";
import useContactsData from "@/utils/queries/hooks/useContactsData";
import { IContactData } from "@/models/contact";
import { OpenGraph } from "next-seo/lib/types";
import { withRedirect } from "@/utils/redirects";
import ContactBody from "../components/contacts/ContactBody";
import { getBrochureData, getNavBarData, getSeoInfo } from "../utils/queries";

const getOpenGraphData = (contactsData?: IContactData): OpenGraph => {
    if (contactsData) {
        return {
            title: contactsData.metadata?.title,
            description: contactsData.metadata?.metaDescription,
            url: contactsData.metadata?.urlCanonical,
            images: [
                {
                    url: contactsData.headImage,
                    alt: contactsData.metadata?.altHeadImage,
                },
            ],
        };
    }
    return {};
};

const Contacts: NextPage = () => {
    const { data: contactsData } = useContactsData();
    // const { data: metaTags } = useQuery({
    //     queryKey: ["metaTags", ESeoPage.CONTACTS],
    //     queryFn: () => getSeoInfo(ESeoPage.CONTACTS),
    // });

    const metadata = getOpenGraphData(contactsData);

    return (
        <>
            <Seo seoInfo={metadata} noindex={!contactsData?.metadata?.index} />
            <ContactBody contactsData={contactsData} />
        </>
        // </Layout>
    );
};

export const getServerSideProps: GetServerSideProps = withRedirect(
    async (): Promise<{
        props: {
            dehydratedState: DehydratedState;
        };
    }> => {
        const queryClient = new QueryClient();

        await Promise.all([
            await queryClient.prefetchQuery(["navBar"], getNavBarData),
            await queryClient.prefetchQuery(["brochures"], getBrochureData),
            await queryClient.prefetchQuery(
                ["metaTags", ESeoPage.CONTACTS],
                () => getSeoInfo(ESeoPage.CONTACTS)
            ),
        ]);

        return {
            props: {
                dehydratedState: dehydrate(queryClient),
            },
        };
    }
);

export default Contacts;
